/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * The status of a validation document in the validation process.
 * Values:
 * - 'processing': Once the document is in the "processing" stage, it means it is undergoing the data extraction
 * process. This stage indicates that the system is working on the document to generate output.
 * - 'processed': The status "processed" signifies that the document has undergone a thorough review, with the user
 * verifying and confirming the accuracy of the extracted information or it can also be a document which got processed
 * automatically through straight through processing. . At this stage, the document is considered complete and accurate
 * for further actions.
 * - 'failed': When a document is labeled as "failed," it indicates that the document has encountered an error during
 * processing. Sometimes there is issue while processing the documents in the server side.
 * This might be due to error in extraction or Internal Server Error.
 */
export var ValidationDocumentStatus;

(function (ValidationDocumentStatus) {
  ValidationDocumentStatus["PROCESSING"] = "processing";
  ValidationDocumentStatus["PROCESSED"] = "processed";
  ValidationDocumentStatus["FAILED"] = "failed";
})(ValidationDocumentStatus || (ValidationDocumentStatus = {}));